import React, {Component, Fragment} from 'react';
import logo from './../../img/general/logo.svg';
import {Link, withRouter} from "react-router-dom";
import {connect} from "react-redux";
import Alert from "../Alerts/Alert";
import {clearCart, clearDeliveryData} from "../../actionCreators";

class LandingHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowAlert: false,
      showAlertText: 'Sure you want go to main page. Cart and delivery data will be cleared.',
      showAlertBtnAction: 'Continue',
      isLinkLogo: false
    }
  }

  closeAlert = (e) => {
    this.setState({
      isShowAlert: false
    })
  };

  showAlert = (e, isLinkLogo) => {
    const {cart} = this.props;
    const {goHomePage} = this;

    if(cart.length !== 0) {
      this.setState({
        isShowAlert: true,
        isLinkLogo: isLinkLogo
      })
    } else {
      goHomePage(isLinkLogo);
    }
  };

  goHomePage = () => {
    const {history, clearCart, clearDeliveryData} = this.props;
    clearCart();
    clearDeliveryData();
    history.push("./#description");
  }

  goHomeLogoPage = () => {
    const {history, clearCart, clearDeliveryData} = this.props;
    clearCart();
    clearDeliveryData();
    history.push("./");
  }

  showAlertRender = () => {
    const {isShowAlert, showAlertText, showAlertBtnAction, isLinkLogo} = this.state;
    const {closeAlert, goHomePage, goHomeLogoPage} = this;
    if(isShowAlert) {
      return <Alert closeAlert={closeAlert} someActionDo={isLinkLogo ? goHomeLogoPage : goHomePage} alertText={showAlertText} btnSomeActionDoText={showAlertBtnAction}/>
    }
  }

  render() {
    const {isShowAddress, categories} = this.props;
    const {showAlertRender, showAlert} = this;
    return (
      <Fragment>
        <header className="header">
          <div className="container">
            <div className="header__inner">
              <div className="logo">
                <a onClick={(e) => showAlert(e,true)}>
                  <img src={logo} alt=""/>
                </a>
              </div>
              <div className="header__who-we-are header__who-we-are--header">
                <a onClick={(e) => showAlert(e,false)}>Wer wir sind?</a>
              </div>
              <div className="header__address">
                <address>
                  {isShowAddress ? (
                    ''
                  ) : (
                    <p>
                      {!categories.shopAddress ? 'loading...' : categories.shopAddress}</p>
                  )}
                </address>
              </div>
            </div>
          </div>
        </header>
        {showAlertRender()}
      </Fragment>
    );
  }
}

export default withRouter(connect((state) => {
  return {
    categories: state.categories,
    cart: state.cart
  }
}, {clearCart, clearDeliveryData})(LandingHeader));


// WEBPACK FOOTER //
// ./src/components/Landing/LandingHeader.js